/**
 * Logo dell'app nelle intestazioni (Andrea 2026-10-08): col tema chiaro il
 * logo bianco sparirebbe sullo sfondo lavanda, quindi si usa lo STESSO
 * logo colorato di viola (public/icon-purple-*.png, generato dal bianco).
 */

import { useTemaEffettivo } from "../../lib/tema";

export function LogoApp({ className = "" }: { className?: string }) {
  const chiaro = useTemaEffettivo() === "chiaro";
  return (
    <img
      src={chiaro ? "/icon-purple-192.png" : "/icon-white-192.png"}
      alt="FantaSquad"
      className={className}
      onError={(e) => {
        e.currentTarget.src = "/icon-192.png";
      }}
    />
  );
}
